class MediaGallery extends HTMLElement {
  constructor() {
    super();
    const productId = this.dataset.productId;
    this.elements = {
      liveRegion: this.querySelector(`[id^="GalleryStatus-${productId}"]`),
      viewer: this.querySelector(`[id^="GalleryViewer-${productId}"]`),
      thumbnails: this.querySelector(`[id^="GalleryThumbnails-${productId}"]`),
    };
    this.mql = window.matchMedia('(min-width: 750px)');
    this.elements.thumbnails && this.setupEventListeners();
    this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches && this.removeListSemantic();
    let buttonsWrapper = this.querySelector('.configurator_slider-buttons');
    let gallery = document.querySelector(`[id="MediaGallery-${productId}"]`);
    let prev = buttonsWrapper?.querySelector('.slider-prev');
    let next = buttonsWrapper?.querySelector('.slider-next');
    close = this.querySelector('.close-button');
    (prev?.addEventListener('click', function () {
      gallery?.previousSlide();
    }),
      next?.addEventListener('click', function () {
        gallery?.nextSlide();
      }),
      close?.addEventListener('click', function () {
        const lastNonConfiguratorPage = localStorage.getItem('lastNonConfiguratorPage');
        lastNonConfiguratorPage ? window.location.assign(lastNonConfiguratorPage) : window.location.assign('/');
      }));
  }
  setupEventListeners() {
    (this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500)),
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', () => {
          this.setActiveMedia(mediaToSwitch.dataset.target, !1, 'click');
        });
      }));
  }
  onSlideChanged(event) {
    if (window.innerWidth < 750) {
      const thumbnail = this.elements.thumbnails.querySelector(
        `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
      );
      this.setActiveMedia(event.detail.currentElement.dataset.mediaId, !1, 'auto');
    }
  }
  setActiveMedia(mediaId, prepend, event) {
    const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
    let videoElement = activeMedia.querySelector('video');
    if (
      (this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      }),
      activeMedia.classList.add('is-active'),
      videoElement && videoElement.load(),
      prepend)
    ) {
      if ((activeMedia.parentElement.prepend(activeMedia), this.elements.thumbnails)) {
        const activeThumbnail2 = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        activeThumbnail2.parentElement.prepend(activeThumbnail2);
      }
      this.elements.viewer.slider && this.elements.viewer.resetPages();
    }
    if (
      (this.preventStickyHeader(),
      window.setTimeout(() => {
        (this.elements.thumbnails && activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft }),
          (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') &&
            activeMedia.scrollIntoView({ behavior: 'smooth' }));
      }),
      this.playActiveMedia(activeMedia),
      !this.elements.thumbnails)
    )
      return;
    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
    (this.setActiveThumbnail(activeThumbnail),
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition));
  }
  setActiveThumbnail(thumbnail) {
    if (!this.elements.thumbnails || !thumbnail) return;
    (thumbnail.querySelector('button').click(),
      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current')),
      thumbnail.querySelector('button').setAttribute('aria-current', 'true'));
    const slider = this.querySelector('.thumbnail-list.slider--mobile');
    if (!slider) return;
    const sliderRect = slider.getBoundingClientRect(),
      thumbnailRect = thumbnail.getBoundingClientRect(),
      slideWidth = thumbnailRect.right - thumbnailRect.left;
    if (!(thumbnailRect.left >= sliderRect.left && thumbnailRect.right <= sliderRect.right)) {
      const slidesSkipped = Math.ceil((sliderRect.left - thumbnailRect.right) / slideWidth),
        scrollAmount =
          thumbnailRect.left < sliderRect.left
            ? -Math.abs(slidesSkipped * slideWidth) - sliderRect.left
            : Math.abs(slidesSkipped * slideWidth) - sliderRect.left;
      slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  }
  announceLiveRegion(activeItem, position) {
    const image = activeItem.querySelector('.product__modal-opener--image img');
    image &&
      ((image.onload = () => {
        (this.elements.liveRegion.setAttribute('aria-hidden', 'false'),
          (this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
            '[index]',
            position,
          )),
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', 'true');
          }, 2e3));
      }),
      (image.src = image.src));
  }
  playActiveMedia(activeItem) {
    window.pauseAllMedia(this.elements.viewer);
    const deferredMedia = activeItem.querySelector('.deferred-media');

    if (deferredMedia) {
      deferredMedia.style.visibility = 'visible';
      deferredMedia.style.pointerEvents = 'auto';
      deferredMedia.style.zIndex = '5';

      deferredMedia.loadContent(false);

      const video = activeItem.querySelector('video');
      if (video) {
        video.style.visibility = 'visible';
        video.style.pointerEvents = 'auto';

        // Adjust height after video metadata is loaded
        video.addEventListener('loadedmetadata', () => {
          const aspectRatio = video.videoHeight / video.videoWidth;
          const containerWidth = deferredMedia.clientWidth;
          const calculatedHeight = containerWidth * aspectRatio;
          const minHeight = 300;
          const viewportHeight = window.innerHeight;
          const maxHeight = viewportHeight * 0.8;
          const computedHeight = Math.max(calculatedHeight, minHeight);

          const finalHeight = computedHeight > maxHeight ? maxHeight : computedHeight;

          Object.assign(video.style, {
            height: finalHeight + 'px',
            maxHeight: '80vh',
            margin: '0 auto',
          });

          Object.assign(deferredMedia.style, {
            height: finalHeight + 'px',
            maxHeight: '80vh',
            display: 'flex',
            justifyContent: 'center',
          });
        });

        video.play();
      }

      setTimeout(() => {
        activeItem.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }, 100);
    }
  }
  preventStickyHeader() {
    ((this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header')),
      this.stickyHeader && this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal')));
  }
  removeListSemantic() {
    this.elements.viewer.slider &&
      (this.elements.viewer.slider.setAttribute('role', 'presentation'),
      this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation')));
  }
  nextSlide() {
    let nextElement = this.elements.viewer.slider.querySelector('.is-active').nextElementSibling;
    for (; nextElement; ) {
      if (
        !nextElement.classList.contains('product__media-item--variant') &&
        nextElement.classList.contains('slide-show')
      ) {
        this.setActiveMedia(nextElement.dataset.mediaId, !1, 'auto');
        return;
      }
      nextElement = nextElement.nextElementSibling;
    }
    const firstSlide = this.elements.viewer.slider.querySelector('.slider__slide:first-child');
    this.setActiveMedia(firstSlide.dataset.mediaId, !1, 'auto');
  }
  previousSlide() {
    let prevElement = this.elements.viewer.slider.querySelector('.is-active').previousElementSibling;
    for (; prevElement; ) {
      if (prevElement.classList.contains('slide-show')) {
        this.setActiveMedia(prevElement.dataset.mediaId, !1, 'auto');
        return;
      }
      prevElement = prevElement.previousElementSibling;
    }
    const lastNonVariantSlide = Array.from(this.elements.viewer.slider.querySelectorAll('.slider__slide'))
      .reverse()
      .find((slide) => !slide.classList.contains('product__media-item--variant'));
    this.setActiveMedia(lastNonVariantSlide.dataset.mediaId, !1, 'auto');
  }
}
customElements.get('media-gallery') || customElements.define('media-gallery', MediaGallery);
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/media-gallery.js.map?v=1729181726
